import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f6ed642"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "welcome" }
const _hoisted_4 = { class: "h0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h0-left" }, "身份：管理员", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("注销")
const _hoisted_7 = {
  key: 0,
  class: "server-status"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h1-left" }, "服务器运作状态")
], -1))
const _hoisted_9 = { class: "h2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h2-left" }, "内存使用", -1))
const _hoisted_11 = { class: "h2-right" }
const _hoisted_12 = { class: "h2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h2-left" }, "磁盘使用", -1))
const _hoisted_14 = { class: "h2-right" }
const _hoisted_15 = { class: "h2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h2-left" }, "CPU使用", -1))
const _hoisted_17 = { class: "h2-right" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "title" }, "设置管理员密码", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "title" }, "站点设置", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "title" }, "About 设置", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "title" }, "附件管理", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "title" }, "文章管理", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "title" }, "邮件设置", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_i_key = _resolveComponent("i-key")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_i_operation = _resolveComponent("i-operation")!
  const _component_i_user = _resolveComponent("i-user")!
  const _component_i_files = _resolveComponent("i-files")!
  const _component_i_document = _resolveComponent("i-document")!
  const _component_i_setting = _resolveComponent("i-setting")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_button, {
            onClick: _ctx.onLogout,
            size: "small",
            class: "h0-right"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        (_ctx.serverStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.textMem), 1)
              ]),
              _createVNode(_component_el_progress, {
                "show-text": false,
                color: _ctx.colorMap,
                percentage: _ctx.percentMem
              }, null, 8, ["color", "percentage"]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.textDisk), 1)
              ]),
              _createVNode(_component_el_progress, {
                "show-text": false,
                color: _ctx.colorMap,
                percentage: _ctx.percentDisk
              }, null, 8, ["color", "percentage"]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.textProcessor), 1)
              ]),
              _createVNode(_component_el_progress, {
                "show-text": false,
                color: _ctx.colorMap,
                percentage: _ctx.percentProcessor
              }, null, 8, ["color", "percentage"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_menu, {
        class: "the-menu",
        "default-active": _ctx.$route.path,
        router: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "/admin/panel/set-password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_i_key)
                ]),
                _: 1
              }),
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/admin/panel/site" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_i_operation)
                ]),
                _: 1
              }),
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/admin/panel/about" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_i_user)
                ]),
                _: 1
              }),
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/admin/panel/files" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_i_files)
                ]),
                _: 1
              }),
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/admin/panel/posts" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_i_document)
                ]),
                _: 1
              }),
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "/admin/panel/email" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_i_setting)
                ]),
                _: 1
              }),
              _hoisted_23
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _createVNode(_component_router_view, { class: "the-router-view" })
  ]))
}